import React, { useEffect, useRef } from "react";
import { Col, InputGroup, DropdownButton, FormControl, Dropdown } from 'react-bootstrap';
import TextareaAutosize from "react-textarea-autosize";

export default function MyListContentTitle(props) {
    const questionIndex = props.index;
    const inputEl = useRef(null);

    // useEffect(() => {
    //     inputEl.current.focus();
    // });

    function render() {

        return (
            <>
                <Col xs={1}>
                    <label>{props.index}.&nbsp;</label>
                </Col>
                <Col>
                    {/* <input type="text" className="w-100 underline" value={props.title} onChange={props.onChange} placeholder="未命名問題" /> */}
                    <TextareaAutosize ref={inputEl}
                        style={{ height: "35px", border: "none", borderBottom: "1px solid" }}
                        minRows={1}
                        // maxRows={8}
                        className="w-100 underline" value={props.title} onChange={props.onChange} placeholder="未命名問題"
                    />
                </Col>
            </>
        );
    }
    return render();
}